import { type Layout, verticalCompactor } from 'react-grid-layout/core';

import type { Tile } from '@/store/tiles/types.ts';

type TilesMapping = Record<string, Tile>;

export type ForexGridLayout = {
  sourceTiles: TilesMapping;
  items: Layout;
};

// staticTileId:  can mark tile with id=staticTileId to stay at its position during compaction
export function compactLayout(layoutItems: Layout, staticTileId?: string): Layout {
  const nbColumns = 1; // maybe TO DO compute from layout, considering Xs and Ws

  // must be done also when also when staticTileId is undefined, to reset previous static marks
  for (const item of layoutItems) {
    item.static = item.i === staticTileId;
  }

  return verticalCompactor.compact(layoutItems, nbColumns);
}

export const convertTilesToLayout = (tiles: readonly Tile[]): ForexGridLayout => ({
  sourceTiles: tiles.reduce<TilesMapping>((mapping, tile) => {
    mapping[tile.tileId] = tile;
    return mapping;
  }, {}),
  items: tiles.map(({ tileId, x, y, w, h }) => ({ i: tileId, x, y, w, h })),
});

export const convertLayoutBackToTiles = (layout: ForexGridLayout): readonly Tile[] =>
  layout.items
    .map(({ i, x, y }) => {
      const tile = layout.sourceTiles[i];
      if (!tile) {
        // not supposed to happen, by construction
        throw new Error('dev error: convertLayoutBackToTiles');
      }
      return { ...tile, x, y };
    })
    .filter(Boolean);

// create a new layout with some tile altered
// avoiding creating new layout elements if unnecessary
export const alterLayout = (
  layout: ForexGridLayout,
  tileId: string,
  tileChanges: Partial<Pick<Tile, 'x' | 'y' | 'w' | 'h'>>,
) => layout.items.map((tile) => (tile.i === tileId ? { ...tile, ...tileChanges } : tile));
